import React from 'react'
import { PageSwoosh } from '../lib/types'

interface ISectionContext {
  isHero?: boolean
  // We rely on isH1Section section to determine which section should contain an H1
  isH1Section?: boolean
  indexInPage?: number
  isGrouped?: boolean
  hasGroupHeading?: boolean
  sectionGroupSwoosh?: PageSwoosh
  isTrustedBySection?: boolean
  isReducedHeroPadding?: boolean
}

export const SectionContext = React.createContext<ISectionContext>({})
